export const BaseDict = {
    NextRaces: "Next {0} Races",
    ViewNextCoupons: " View next {0} coupons",
    ViewAll: "View all",
    Left: "Left",
    Right: "Right",
    StartingPrice: "SP",
    NonRunner: "NR"
};
//# sourceMappingURL=dict.js.map